import React from 'react';
import './AdSection.scss';

const AdSection = () => {
  return (
    <section className="ad-section">
      <div className="ad-content" style={{ backgroundImage: `url('what-to-wear-with-a-navy-t-shirt.png')` }}>
        <div className="ad-text">
          <h2>Double Plaloma</h2>
          <p>สินค้าใหม่แนะนำ!</p>
        </div>
      </div>
    </section>
  );
};

export default AdSection;
